// Server fetch timeout (fail fast; avoids Vercel 300s runtime timeout with no error)
export const FETCH_TIMEOUT_MS = 25_000

// Cookies
export const COOKIE_DAYS_TO_EXPIRE = 7

// Datagroups
export const DATAGROUP_ID_COCA_COLA_LATAM_DSM_FSA = 'e33ddcf0-f39b-394a-8196-d3e292babee2'

// Notifications
export const NOTIFICATIONS_POSITION = 'top-right'
export const NOTIFICATIONS_Z_INDEX = 1000
export const NOTIFICATIONS_LIMIT = 5

// Product types
export const PRODUCT_TYPE = {
  BRAND: 'brand',
  AGENCY: 'agency',
}
